import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import PortalVue from "portal-vue";
import VueApollo from "vue-apollo";
import apolloProvider from "../graphql.apollo";
import vSelect from "vue-select";

//Styles
import "@/assets/css/app.css";
import "@mdi/font/css/materialdesignicons.css";
import "vue-select/dist/vue-select.css";

/**
 * Register an event bus to communicate between components
 */
export const eventBus = new Vue();

/**
 * Global mixins
 *
 * This makes e.g. trailingSlash available in our components as this.trailingSlash(), instead of
 * having to import it each time. Only use this for widely used helpers; otherwise import
 * them explicitly where needed, e.g. as we do with getNested().
 */
import { trailingSlash } from "./components/mixins/helpers";

Vue.mixin({
  methods: {
    trailingSlash,
  },
});

Vue.component("VSelect", vSelect);

Vue.config.productionTip = false;

Vue.use(PortalVue);
Vue.use(VueApollo);
Vue.component("v-select", vSelect);

// Add event to make form.io sections collapsible with enter
document.addEventListener("keydown", e => {
  if (e.key === "Enter" && e.target.classList.contains("collapsible-title")) {
    e.target.click();
  }
});

new Vue({
  router,
  store,
  apolloProvider,
  render: h => h(App)
}).$mount("#app");
